import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=138cb474&scoped=true&"
import script from "./TestResult.vue?vue&type=script&lang=ts&"
export * from "./TestResult.vue?vue&type=script&lang=ts&"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=138cb474&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cb474",
  null
  
)

component.options.__file = "TestResult.vue"
export default component.exports